"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderMarker = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const helpers_1 = require("./helpers");
const SliderMarker = ({ markerIndex, markersTotal, slider }) => {
    const left = react_1.default.useCallback(({ sizes }) => {
        if (markerIndex === 0) {
            return `${sizes[1] / 2}px`;
        }
        else if (markerIndex === markersTotal - 1) {
            return `calc(${(markerIndex / (markersTotal - 1)) * 100}% - ${sizes[1] + sizes[1] / 2}px)`;
        }
        else {
            return `calc(${(markerIndex / (markersTotal - 1)) * 100}% - ${sizes[1] / 2}px)`;
        }
    }, [markerIndex, markersTotal]);
    return (react_1.default.createElement(foundations_1.Box, { as: "span", sx: {
            backgroundColor: (0, helpers_1.getIsMarkerInRange)(slider.value, slider.min, slider.max, slider.step, markerIndex)
                ? "slider-onsurface-selected"
                : "slider-onsurface-notselected",
            borderRadius: "50%",
            display: "block",
            height: 1,
            left,
            position: "absolute",
            top: ({ sizes }) => `${sizes[3] + sizes[1] / 2}px`,
            width: 1
        } }));
};
exports.SliderMarker = SliderMarker;
//# sourceMappingURL=SliderMarker.js.map